module.exports = __webpack_public_path__ + "static/Mask-0ca245c0c7b639c06a8e547a83715032.png";